// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"17897eca","231":"a7bad8ae","326":"572f7e3b","435":"2c90dc0f","453":"df6bb073"}[chunkId] + ".chunk.js";
};